import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuthContext } from '../providers';
import {
  getHasUser
} from '../store';

export function useRequireUser() {
  const location = useLocation();
  const {
    signInPathname
  } = useAuthContext();
  const redirectTo = useMemo(() => (signInPathname), [signInPathname]);
  const hasUser = useSelector(getHasUser);

  return {
    isBlocked: !hasUser,
    location,
    redirectTo
  };
}

export default useRequireUser;
